import { navigateTo } from "./navigation";

export function useCoachApplicationPageExperiment() {
    return {
        openCoachApplyQuiz: () => {
            void navigateTo(route("coach-apply"));
        },
    };
}
